import React, { useMemo } from 'react';

import { Autocomplete, Input } from '@lyearn/ui';

import { getRatingOptions } from '../../consts';
import RatingItemNumber from '../RatingItemNumber';
import { RatingInputProps } from './types';

const RatingInput = (props: RatingInputProps) => {
  const { max, value, onChange, openOnFocus = false, className = '' } = props;
  const options = useMemo(() => getRatingOptions(max), [max]);

  return (
    <Autocomplete
      className={className}
      getOptionLabel={(option) => option}
      openOnFocus={openOnFocus}
      optionLabelRenderer={(option) => <RatingItemNumber value={option} />}
      options={options}
      renderInput={(params) => <Input {...params} autoFocus />}
      value={value}
      onChange={onChange}
    />
  );
};

export default RatingInput;
